import { Navigate } from "react-router-dom";
import { isViewer } from "../utils/permissions";

const BlockViewerRoute = ({ children }) => {
  if (isViewer()) {
    return <Navigate to="/admindashboard" replace />;
  }
  return children;
};

export default BlockViewerRoute;
